import { render, staticRenderFns } from "./CarouselPagination.vue?vue&type=template&id=e4f2fa16&scoped=true&"
import script from "./CarouselPagination.vue?vue&type=script&lang=js&"
export * from "./CarouselPagination.vue?vue&type=script&lang=js&"
import style0 from "./CarouselPagination.vue?vue&type=style&index=0&id=e4f2fa16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f2fa16",
  null
  
)

export default component.exports